import AddIcon from "@mui/icons-material/Add";
import { Fab } from "@mui/material";
import { useNavigate } from "react-router";
import { PageContent } from "../../components/core/PageContent/PageContent";
import { PageHeader } from "../../components/core/PageHeader/PageHeader";
import { useAuth } from "../../contexts/authContext";
import { UserRoles } from "../../types/core/auth.types";
import { dictionary } from "../../utils/core/dictionary";
import { HierarchyList } from "./HierarchyList";

export function HierarchyPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const readOnly = user
    ? user.roles.indexOf(UserRoles.Admin) > -1
      ? false
      : true
    : true;
  const headerButtons = [
    <Fab
      key={0}
      color="primary"
      aria-label="add"
      size="medium"
      onClick={() => {
        navigate(`/hierarchy/create`);
      }}
    >
      <AddIcon />
    </Fab>,
  ];

  return (
    <>
      <PageHeader
        title={dictionary.HIERARCHY}
        buttons={readOnly ? null : headerButtons}
        xs={6}
      />
      <PageContent>
        <HierarchyList readOnly={readOnly} />
      </PageContent>
    </>
  );
}
